import { Component } from '@angular/core';

@Component({
    selector: 'app-footer',
    template: `
        <div class="layout-footer p-m-0 p-p-0">
            <div class="ui-g">
                <div class="ui-g-12 p-text-center">
                    <div class="layout-footer-appname"> DataSense.BI Controller v2.2.1 |(c) 2026 Data Sense d.o.o.</div>
                   
                </div>
            </div>
        </div>
    `
})
export class AppFooterComponent {

}
